"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/external-account.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fexternal-account.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.externalAccountErrorCodeToJSON = exports.externalAccountErrorCodeFromJSON = exports.ExternalAccount = exports.ExternalAccountErrorCode = void 0;
const external_bank_1 = require("./external-bank");
const external_card_1 = require("./external-card");
const protobufPackage = 'com.step.common.proto';
/**
 * Error codes describing failures related to adding, charging, or paying out external accounts.
 */
var ExternalAccountErrorCode;
(function (ExternalAccountErrorCode) {
    ExternalAccountErrorCode["INVALID_ERROR_CODE"] = "INVALID_ERROR_CODE";
    ExternalAccountErrorCode["INVALID_EXTERNAL_CARD_TYPE"] = "INVALID_EXTERNAL_CARD_TYPE";
    ExternalAccountErrorCode["UNSUPPORTED_CARD"] = "UNSUPPORTED_CARD";
    ExternalAccountErrorCode["CVV_REQUIRED"] = "CVV_REQUIRED";
    ExternalAccountErrorCode["AVS_NOT_MATCHED"] = "AVS_NOT_MATCHED";
    ExternalAccountErrorCode["CVV_NOT_MATCHED"] = "CVV_NOT_MATCHED";
    ExternalAccountErrorCode["CARD_DECLINED"] = "CARD_DECLINED";
    ExternalAccountErrorCode["CARD_EXPIRED"] = "CARD_EXPIRED";
    ExternalAccountErrorCode["CARD_NUMBER_INVALID"] = "CARD_NUMBER_INVALID";
    ExternalAccountErrorCode["CARD_EXPIRATION_INVALID"] = "CARD_EXPIRATION_INVALID";
    /**
     * QUOTA_EXCEEDED - Quota of the maximum number of active external cards
     */
    ExternalAccountErrorCode["QUOTA_EXCEEDED"] = "QUOTA_EXCEEDED";
    ExternalAccountErrorCode["NAME_MISMATCH"] = "NAME_MISMATCH";
    ExternalAccountErrorCode["PROCESSING_ERROR"] = "PROCESSING_ERROR";
    ExternalAccountErrorCode["CHARGE_ALREADY_REFUNDED"] = "CHARGE_ALREADY_REFUNDED";
    ExternalAccountErrorCode["CHARGE_EXPIRED"] = "CHARGE_EXPIRED";
    ExternalAccountErrorCode["CHARGE_UNDER_REVIEW"] = "CHARGE_UNDER_REVIEW";
    ExternalAccountErrorCode["MISSING_IP"] = "MISSING_IP";
    /**
     * CARD_PAYOUTS_DISABLED - If user's payouts are disabled on provider
     */
    ExternalAccountErrorCode["CARD_PAYOUTS_DISABLED"] = "CARD_PAYOUTS_DISABLED";
    /**
     * CARD_ERRORED_STATUS - If the card is in errored state on provider
     */
    ExternalAccountErrorCode["CARD_ERRORED_STATUS"] = "CARD_ERRORED_STATUS";
    /**
     * UNSUPPORTED_COUNTRY - If the card country is not supported.
     */
    ExternalAccountErrorCode["UNSUPPORTED_COUNTRY"] = "UNSUPPORTED_COUNTRY";
    /**
     * PAYMENT_INTENT_PROCESSING - If the payment intent is currently processing and can't be canceled.
     */
    ExternalAccountErrorCode["PAYMENT_INTENT_PROCESSING"] = "PAYMENT_INTENT_PROCESSING";
    /**
     * SHARED_QUOTA_EXCEEDED - Quota of the maximum number of users or families that can add the same
     * external account
     */
    ExternalAccountErrorCode["SHARED_QUOTA_EXCEEDED"] = "SHARED_QUOTA_EXCEEDED";
    ExternalAccountErrorCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ExternalAccountErrorCode || (exports.ExternalAccountErrorCode = ExternalAccountErrorCode = {}));
function createBaseExternalAccount() {
    return { id: '', name: '', card: undefined, bank: undefined };
}
exports.ExternalAccount = {
    fromJSON(object) {
        const message = { id: isSet(object.id) ? globalThis.String(object.id) : '' };
        if (isSet(object.name)) {
            message.name = globalThis.String(object.name);
        }
        if (isSet(object.card)) {
            message.card = external_card_1.ExternalCard.fromJSON(object.card);
        }
        if (isSet(object.bank)) {
            message.bank = external_bank_1.ExternalBank.fromJSON(object.bank);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.name !== undefined && message.name !== '') {
            obj.name = message.name;
        }
        if (message.card !== undefined) {
            obj.card = external_card_1.ExternalCard.toJSON(message.card);
        }
        if (message.bank !== undefined) {
            obj.bank = external_bank_1.ExternalBank.toJSON(message.bank);
        }
        return obj;
    },
    create(base) {
        return exports.ExternalAccount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseExternalAccount();
        message.id = object.id ?? '';
        message.name = object.name ?? '';
        message.card = (object.card !== undefined && object.card !== null)
            ? external_card_1.ExternalCard.fromPartial(object.card)
            : undefined;
        message.bank = (object.bank !== undefined && object.bank !== null)
            ? external_bank_1.ExternalBank.fromPartial(object.bank)
            : undefined;
        return message;
    },
};
function externalAccountErrorCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ERROR_CODE':
            return ExternalAccountErrorCode.INVALID_ERROR_CODE;
        case 1:
        case 'INVALID_EXTERNAL_CARD_TYPE':
            return ExternalAccountErrorCode.INVALID_EXTERNAL_CARD_TYPE;
        case 2:
        case 'UNSUPPORTED_CARD':
            return ExternalAccountErrorCode.UNSUPPORTED_CARD;
        case 3:
        case 'CVV_REQUIRED':
            return ExternalAccountErrorCode.CVV_REQUIRED;
        case 4:
        case 'AVS_NOT_MATCHED':
            return ExternalAccountErrorCode.AVS_NOT_MATCHED;
        case 5:
        case 'CVV_NOT_MATCHED':
            return ExternalAccountErrorCode.CVV_NOT_MATCHED;
        case 6:
        case 'CARD_DECLINED':
            return ExternalAccountErrorCode.CARD_DECLINED;
        case 7:
        case 'CARD_EXPIRED':
            return ExternalAccountErrorCode.CARD_EXPIRED;
        case 8:
        case 'CARD_NUMBER_INVALID':
            return ExternalAccountErrorCode.CARD_NUMBER_INVALID;
        case 9:
        case 'CARD_EXPIRATION_INVALID':
            return ExternalAccountErrorCode.CARD_EXPIRATION_INVALID;
        case 10:
        case 'QUOTA_EXCEEDED':
            return ExternalAccountErrorCode.QUOTA_EXCEEDED;
        case 11:
        case 'NAME_MISMATCH':
            return ExternalAccountErrorCode.NAME_MISMATCH;
        case 12:
        case 'PROCESSING_ERROR':
            return ExternalAccountErrorCode.PROCESSING_ERROR;
        case 13:
        case 'CHARGE_ALREADY_REFUNDED':
            return ExternalAccountErrorCode.CHARGE_ALREADY_REFUNDED;
        case 14:
        case 'CHARGE_EXPIRED':
            return ExternalAccountErrorCode.CHARGE_EXPIRED;
        case 15:
        case 'CHARGE_UNDER_REVIEW':
            return ExternalAccountErrorCode.CHARGE_UNDER_REVIEW;
        case 16:
        case 'MISSING_IP':
            return ExternalAccountErrorCode.MISSING_IP;
        case 17:
        case 'CARD_PAYOUTS_DISABLED':
            return ExternalAccountErrorCode.CARD_PAYOUTS_DISABLED;
        case 18:
        case 'CARD_ERRORED_STATUS':
            return ExternalAccountErrorCode.CARD_ERRORED_STATUS;
        case 19:
        case 'UNSUPPORTED_COUNTRY':
            return ExternalAccountErrorCode.UNSUPPORTED_COUNTRY;
        case 20:
        case 'PAYMENT_INTENT_PROCESSING':
            return ExternalAccountErrorCode.PAYMENT_INTENT_PROCESSING;
        case 21:
        case 'SHARED_QUOTA_EXCEEDED':
            return ExternalAccountErrorCode.SHARED_QUOTA_EXCEEDED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ExternalAccountErrorCode.UNRECOGNIZED;
    }
}
exports.externalAccountErrorCodeFromJSON = externalAccountErrorCodeFromJSON;
function externalAccountErrorCodeToJSON(object) {
    switch (object) {
        case ExternalAccountErrorCode.INVALID_ERROR_CODE:
            return 'INVALID_ERROR_CODE';
        case ExternalAccountErrorCode.INVALID_EXTERNAL_CARD_TYPE:
            return 'INVALID_EXTERNAL_CARD_TYPE';
        case ExternalAccountErrorCode.UNSUPPORTED_CARD:
            return 'UNSUPPORTED_CARD';
        case ExternalAccountErrorCode.CVV_REQUIRED:
            return 'CVV_REQUIRED';
        case ExternalAccountErrorCode.AVS_NOT_MATCHED:
            return 'AVS_NOT_MATCHED';
        case ExternalAccountErrorCode.CVV_NOT_MATCHED:
            return 'CVV_NOT_MATCHED';
        case ExternalAccountErrorCode.CARD_DECLINED:
            return 'CARD_DECLINED';
        case ExternalAccountErrorCode.CARD_EXPIRED:
            return 'CARD_EXPIRED';
        case ExternalAccountErrorCode.CARD_NUMBER_INVALID:
            return 'CARD_NUMBER_INVALID';
        case ExternalAccountErrorCode.CARD_EXPIRATION_INVALID:
            return 'CARD_EXPIRATION_INVALID';
        case ExternalAccountErrorCode.QUOTA_EXCEEDED:
            return 'QUOTA_EXCEEDED';
        case ExternalAccountErrorCode.NAME_MISMATCH:
            return 'NAME_MISMATCH';
        case ExternalAccountErrorCode.PROCESSING_ERROR:
            return 'PROCESSING_ERROR';
        case ExternalAccountErrorCode.CHARGE_ALREADY_REFUNDED:
            return 'CHARGE_ALREADY_REFUNDED';
        case ExternalAccountErrorCode.CHARGE_EXPIRED:
            return 'CHARGE_EXPIRED';
        case ExternalAccountErrorCode.CHARGE_UNDER_REVIEW:
            return 'CHARGE_UNDER_REVIEW';
        case ExternalAccountErrorCode.MISSING_IP:
            return 'MISSING_IP';
        case ExternalAccountErrorCode.CARD_PAYOUTS_DISABLED:
            return 'CARD_PAYOUTS_DISABLED';
        case ExternalAccountErrorCode.CARD_ERRORED_STATUS:
            return 'CARD_ERRORED_STATUS';
        case ExternalAccountErrorCode.UNSUPPORTED_COUNTRY:
            return 'UNSUPPORTED_COUNTRY';
        case ExternalAccountErrorCode.PAYMENT_INTENT_PROCESSING:
            return 'PAYMENT_INTENT_PROCESSING';
        case ExternalAccountErrorCode.SHARED_QUOTA_EXCEEDED:
            return 'SHARED_QUOTA_EXCEEDED';
        case ExternalAccountErrorCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.externalAccountErrorCodeToJSON = externalAccountErrorCodeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=external-account.js.map